// extracted by mini-css-extract-plugin
export default {"p_tye":"_69f5284355","slcted":"f94146d9e8","slc_color":"aefd9c7de3","item_p":"_0b6ab16f30","r0":"_336b168d98"};